
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {dictInstrumentApi} from "@/api/organization";
  @Component({
    name: 'SettingInstrData',
  })
  export default class Home extends Vue {
    @Prop()
    dictInstrId !: number;
    @Prop()
    data !: string;
    editInstrData = {
      visible: false,
      elements: [] as any,
      prop: {} as any
    }
    created(){
      this.dictInstrChanged(null);
    }
    onSettingInstrData(){
      if(!this.dictInstrId){
        this.$message.warning("请先选择器具名称！");
        return;
      }
      this.editInstrData.visible = true;
    }
    onSave() {
      this.$emit("onSave", JSON.stringify(this.editInstrData.prop));
      this.onClose();
    }
    onClose() {
      this.editInstrData.visible = false;
    }
    @Watch("data")
    valueChanged(val: any) {
      this.editInstrData.prop = JSON.parse(val || "{}");
    }
    @Watch("dictInstrId")
    dictInstrChanged(func: any) {
      dictInstrumentApi.getOne({id: this.dictInstrId}).then((r: any) => {
        if(r.data.result === 0){
          const rData = r.data.data;
          if(rData == null) return;
          this.editInstrData.elements = (rData.data) ? JSON.parse(rData.data) : [];
          if (this.editInstrData.elements.length === 0) {
            this.$message.warning("本器具暂不支持设置此数据！");
            this.onClose();
            return;
          }
          this.editInstrData.prop = JSON.parse(this.data || "{}") ;
          if(func){
            func();
          }
        }
      });
    }
  }
